import { Component, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { ReportOrder } from 'src/app/models/ReportOrder';
import { ResponseReportOrderAddress } from 'src/app/models/ResponseReportOrderAddress';
import { SearchReport } from 'src/app/models/SearchReport';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { ReportService } from 'src/app/services/report.service';
import { CONSTANTES, getToken } from 'src/app/shared/global';

declare var jQuery: any;

@Component({
  selector: 'app-orders-postal-data-report',
  templateUrl: './orders-postal-data-report.component.html',
  styleUrls: ['./orders-postal-data-report.component.scss']
})
export class OrdersPostalDataReportComponent implements OnInit {
  displayedColumns: string[] = ['orderNumber', 'dateOrder', 'clothes', 'name', 'company', 'address'];
  public period : Date;
  public form: FormGroup;
  public dateFromSelect: Date;
  public dateToSelect: Date;
  public search : boolean = false;
  public total: number=0;

  @ViewChild(MatSort) sort: MatSort;

  public dataSource : MatTableDataSource<ResponseReportOrderAddress>;
  public dataTotal : ResponseReportOrderAddress[]; 
  
  constructor(private reportService : ReportService, private spinner: NgxSpinnerService,private toastr: ToastrService, 
    private authService: AuthenticationService,private router: Router) { }

  ngOnInit() {
    this.spinner.show();  
    try{
      jQuery.getScript(CONSTANTES.menu);
    } catch(Error){
      this.router.navigate(['login']);
    }

    this.form = new FormGroup({
      'dateFrom': new FormControl('', Validators.required),
      'dateTo': new FormControl('', Validators.required),
    });

    this.spinner.hide();
  }

  loadReport() {
    let reportOrder = new ReportOrder();
    reportOrder.searchReport = new SearchReport();

    if(this.dateFromSelect != null && this.dateToSelect != null){
      reportOrder.searchReport.toDate = this.dateToSelect;
      reportOrder.searchReport.fromDate = this.dateFromSelect;
    }else{
      reportOrder.searchReport.toDate = null;
      reportOrder.searchReport.fromDate = null;
    }

    reportOrder.searchReport.clothes = null;
    reportOrder.searchReport.family = null;
    reportOrder.searchReport.nid = null;
    reportOrder.searchReport.subFamily = null;
    reportOrder.searchReport.type = null;

    if (this.dateFromSelect == null && this.dateToSelect == null) {
      this.toastr.info("DEBE RELLENAR EL PERIODO");
    }
    else if (this.dateFromSelect == this.dateToSelect) {
      this.toastr.info("NO PUEDEN COINCIDIR LAS FECHAS");
    }
    else if (this.dateFromSelect > this.dateToSelect) {
      this.toastr.info("LA FECHA DE FIN NO PUEDE SER ANTERIOR A LA INCIO");
    }
    else if ((this.dateToSelect == null && this.dateFromSelect != null) || (this.dateToSelect != null && this.dateFromSelect == null)) {
      this.toastr.info("DEBE RELLENAR EL PERIODO DE MANERA COMPLETA");
    } else {

      this.search = false;

      this.spinner.show();
      this.reportService.getReportOrderAddress(reportOrder).subscribe(
        data => {
          if (getToken(data)) {
            if (data.responseReportAddressOrder === null || data.responseReportAddressOrder.length === 0) {
              this.search = false;
              this.toastr.info("NO EXISTEN DATOS PARA MOSTRAR", "INFO");
            } else {
              this.search = true;
              this.dataSource = new MatTableDataSource(data.responseReportAddressOrder);
              this.dataSource.sort = this.sort;
              this.dataTotal = data.responseReportAddressOrder;
              this.total = this.dataTotal.length;             
            }
          }
          this.spinner.hide();
        }, error => {
          this.toastr.error(error);
          this.spinner.hide();
          this.logOut();
        }
      );
      this.spinner.hide();
    }
  }

  logOut() {
    let infoUser = {
      userName: localStorage.getItem("nid")
    }
    this.authService.logOut(infoUser).subscribe(
      data => {
        localStorage.clear();
        this.router.navigate(['login']);
      }
    );
  } 

  getTotalCost() {
    return this.total;
  }

}
